/** Acción del header que abre el alta (mismo patrón que «Nuevo caso» en Custodia). */
export const INGEST_NEW_PROJECT_HEADER_ACTION = 'new';

export interface IngestProjectCreateFormFields {
  name: string;
  description: string;
  folder_path: string;
  is_active: boolean;
}

export interface IngestProjectCreatePanelState {
  creating: boolean;
  form: IngestProjectCreateFormFields;
}

export function emptyIngestProjectCreateForm(): IngestProjectCreateFormFields {
  return {
    name: '',
    description: '',
    folder_path: '',
    is_active: true,
  };
}

export function isIngestCreatePanelOpen(creating: boolean): boolean {
  return creating === true;
}

export function shouldHandleIngestNewProjectHeaderAction(actionId: string): boolean {
  return actionId === INGEST_NEW_PROJECT_HEADER_ACTION;
}

/** Abre el alta y limpia el borrador (también se usa al pulsar de nuevo «Nuevo expediente»). */
export function openIngestCreatePanel(): IngestProjectCreatePanelState {
  return {
    creating: true,
    form: emptyIngestProjectCreateForm(),
  };
}

export function closeIngestCreatePanel(): IngestProjectCreatePanelState {
  return {
    creating: false,
    form: emptyIngestProjectCreateForm(),
  };
}

/** Editar cierra el alta para no mostrar dos paneles a la vez. */
export function closeIngestCreatePanelForEdit(): IngestProjectCreatePanelState {
  return closeIngestCreatePanel();
}

/** Tras un alta exitosa el formulario se oculta (como Cancelar). */
export function closeIngestCreatePanelAfterSuccess(): IngestProjectCreatePanelState {
  return closeIngestCreatePanel();
}

export function ingestProjectsEmptyListHint(creating: boolean): string {
  if (creating) {
    return 'Completa el formulario de nuevo expediente o recarga la lista.';
  }
  return 'Crea uno nuevo con «Nuevo expediente» o recarga la lista.';
}
